import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IPolicyPersonDetails } from '../../..';
import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';

export const initialValues = {
  fullName: '',
  dateOfBirth: '',
  phoneType: 'MOBILE',
  phoneNumber: '',
  nationalityOne: '',
  isTaxable: true,
  occupationClass: '',
  profession: '',
  country: '',
  zone: '',
  city: '',
  street: '',
  building: '',
  addressDetails: '',
  addressDetailsArabic: '',
  personCode: '',
};

export const getSections = (
  data: IPolicyPersonDetails,
  lists: Record<string, Record<string, string>>,
  section: string
): IDynamicFormWidgetSection[] => {
  const isPayer = section === 'payer';
  return [
    {
      sectionTitle: 'General Details',
      inputs: {
        personCode: {
          name: 'personCode',
          title: 'Person Code',
          placeholder: 'Person Code',
          type: FormFieldType.text,
          value: isPayer
            ? data?.Persons?.payer?.personCode
            : data?.Persons?.owner?.personCode,
          required: true,
          minCharacters: 2,
          maxCharacters: 300,
          disabled: true,
          hidden: true,
        },
        fullName: {
          name: 'fullName',
          title: 'Full Name',
          placeholder: 'Full Name',
          type: FormFieldType.text,
          value: isPayer
            ? data?.Persons?.payer?.fullName
            : data?.Persons?.owner?.fullName,
          required: true,
          minCharacters: 2,
          maxCharacters: 300,
          disabled: true,
        },
        dateOfBirth: {
          name: 'dateOfBirth',
          title: 'Date of Birth',
          placeholder: 'Date of Birth',
          type: FormFieldType.date,
          value: isPayer
            ? data?.Persons?.payer?.dateOfBirth
            : data?.Persons?.owner?.dateOfBirth,
          maxDate: new Date(),
          required: false,
          disabled: true,
        },
        phoneType: {
          name: 'phoneType',
          title: 'Phone Type',
          type: FormFieldType.select,
          placeholder: 'Phone Type',
          value: isPayer
            ? data?.Persons?.payer?.phoneType
            : data?.Persons?.owner?.phoneType,
          selectOptions: lists.phoneType,
        },
        phoneNumber: {
          name: 'phoneNumber',
          title: 'Phone Number',
          type: FormFieldType.phoneNumber,
          placeholder: 'Phone Number',
          value: isPayer
            ? data?.Persons?.payer?.phoneNumber
            : data?.Persons?.owner?.phoneNumber,
          required: false,
          editCountryCode: false,
        },
        nationalityOne: {
          name: 'nationalityOne',
          title: 'Nationality',
          placeholder: 'Nationality',
          type: FormFieldType.select,
          value: isPayer
            ? data?.Persons?.payer?.nationalityOneCode
            : data?.Persons?.owner?.nationalityOneCode,
          selectOptions: lists.nationalities,
          required: false,
        },
      },
    },
    {
      sectionTitle: 'Business Details',
      inputs: {
        isTaxable: {
          name: 'isTaxable',
          title: 'Taxable',
          placeholder: 'Taxable',
          type: FormFieldType.switch,
          value: isPayer
            ? data?.Persons?.payer?.isTaxable
            : data?.Persons?.owner?.isTaxable,
          required: false,
          disabled: true,
        },
        occupationClass: {
          name: 'occupationClass',
          title: 'Occupation Class',
          placeholder: 'Occupation Class',
          type: FormFieldType.select,
          value: isPayer
            ? data?.Persons?.payer?.occupationClassCode
            : data?.Persons?.owner?.occupationClassCode,

          selectOptions: lists.occupationClasses,
        },
        profession: {
          name: 'profession',
          title: 'Profession',
          placeholder: 'Profession',
          type: FormFieldType.text,
          value: isPayer
            ? data?.Persons?.payer?.profession
            : data?.Persons?.owner?.profession,
          minCharacters: 2,
          maxCharacters: 100,
        },
      },
    },
    {
      sectionTitle: 'Address Details',
      inputs: {
        country: {
          name: 'country',
          title: 'Country',
          placeholder: 'Country',
          type: FormFieldType.select,
          value: isPayer
            ? data?.Persons?.payer?.countryCode
            : data?.Persons?.owner?.countryCode,
          selectOptions: lists.countries,
          required: true,
        },
        zone: {
          name: 'zone',
          title: 'Zone',
          placeholder: 'Zone',
          type: FormFieldType.select,
          value: isPayer
            ? data?.Persons?.payer?.zone
            : data?.Persons?.owner?.zone,
          selectOptions: lists.zone,
        },
        city: {
          name: 'city',
          title: 'City',
          placeholder: 'City',
          type: FormFieldType.text,
          value: isPayer
            ? data?.Persons?.payer?.city
            : data?.Persons?.owner?.city,
          minCharacters: 2,
          maxCharacters: 100,
          required: true,
        },
        street: {
          name: 'street',
          title: 'Street',
          placeholder: 'Street',
          type: FormFieldType.text,
          value: isPayer
            ? data?.Persons?.payer?.street
            : data?.Persons?.owner?.street,
          minCharacters: 2,
          maxCharacters: 100,
        },
        building: {
          name: 'building',
          title: 'Building',
          placeholder: 'Building',
          type: FormFieldType.text,
          value: isPayer
            ? data?.Persons?.payer?.building
            : data?.Persons?.owner?.building,
          minCharacters: 2,
          maxCharacters: 100,
        },
        addressDetails: {
          name: 'addressDetails',
          title: 'Address Details',
          placeholder: 'Address Details',
          type: FormFieldType.text,
          value: isPayer
            ? data?.Persons?.payer?.addressDetails
            : data?.Persons?.owner?.addressDetails,
          minCharacters: 2,
          maxCharacters: 300,
        },
        addressDetailsArabic: {
          name: 'addressDetailsArabic',
          title: 'Address Details Arabic',
          placeholder: 'Address Details Arabic',
          type: FormFieldType.text,
          value: isPayer
            ? data?.Persons?.payer?.addressDetailsArabic
            : data?.Persons?.owner?.addressDetailsArabic,
          minCharacters: 2,
          maxCharacters: 300,
        },
      },
    },
  ];
};
